import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import Cookies from 'js-cookie'; // Añade esta importación
import '../../styles/solicitudes.css';

function GestionSolicitudes() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [roles, setRoles] = useState([]);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get(`gestion-solicitudes/`, { withCredentials: true })
      .then(response => {
        setSolicitudes(response.data);
      })
      .catch(error => {
        setError('Error al cargar las solicitudes');
      });
  }, []);

  // Cargar roles
  useEffect(() => {
    api.get(`roles/`)
      .then(response => {
        setRoles(response.data.roles);
      })
      .catch(error => {
        setError('Error al cargar los roles');
        // Fallback: si falla la carga de roles, usamos una lista por defecto
        setRoles(['socio', 'administrador']);
      });
  }, []);

  const handleAccion = (solicitudId, accion, rol = 'socio') => {
    const csrftoken = Cookies.get('csrftoken'); // Obtiene el token CSRF de la cookie
    api.post(`gestion-solicitudes/`, { solicitud_id: solicitudId, accion, rol }, {
      withCredentials: true,
      headers: {
        'X-CSRFToken': csrftoken, // Añade el token al encabezado
      },
    })
      .then(response => {
        setSolicitudes(solicitudes.filter(s => s.id !== solicitudId));
        setMessage(response.data.message);
        setError('');
      })
      .catch(error => {
        setError('Error al procesar la solicitud');
        setMessage('');
      });
  };

  if (error) {
    return (
      <div className="gestion-solicitudes">
        <h1>Gestionar Solicitudes</h1>
        <p className="error">{error}</p>
      </div>
    );
  }

  return (
    <div className="page gestion-solicitudes">
      <h1>Gestionar Solicitudes</h1>
      {message && <p className="success">{message}</p>}
      {solicitudes.length === 0 ? (
        <p>No hay solicitudes pendientes.</p>
      ) : (
        <ul>
          {solicitudes.map(solicitud => (
            <li key={solicitud.id} className="solicitud-item">
              <p><strong>Nombre:</strong> {solicitud.nombre} {solicitud.apellidos}</p>
              <p><strong>Email:</strong> {solicitud.email}</p>
              <p><strong>Fecha:</strong> {new Date(solicitud.fecha_solicitud).toLocaleString()}</p>
              <div className="acciones">
                <label>Asignar rol: </label>
                <select id={`rol-${solicitud.id}`}>
                  {roles.map(rol => (
                      <option key={rol} value={rol}>
                        {rol.charAt(0).toUpperCase() + rol.slice(1)} {/* Capitaliza el rol para mostrarlo */}
                      </option>
                    ))}
                </select>
                <button
                  onClick={() => handleAccion(solicitud.id, 'aprobar', document.getElementById(`rol-${solicitud.id}`).value)}
                  className="aprobar"
                >
                  Aprobar
                </button>
                <button
                  onClick={() => handleAccion(solicitud.id, 'rechazar')}
                  className="rechazar"
                >
                  Rechazar
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default GestionSolicitudes;